import React, { useEffect, useState } from 'react'
import { Layout, theme, Row, Col, Menu, Affix, Button, Card, Form, Input, message, Modal } from 'antd'

import '../../Components/Sidebar/sidebar.scss'
import login_logo from '../../assets/logo.svg'
import profile from '../../assets/profile/animoji-1.png'
import Sider from 'antd/es/layout/Sider'
import dash from '../../assets/dash.svg'
import { Header } from 'antd/es/layout/layout'
import ReferralBanner from '../../Components/DashboardComponents/referralBanner'
import token from '../../assets/token.svg'
import { DownloadOutlined, UploadOutlined, InfoCircleOutlined } from '@ant-design/icons'
import userService from '../../services/userService'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import MyEarningsGraph from '../../Components/DashboardComponents/myEarningsGraph'
import { Content } from 'antd/es/layout/layout'
import tdxDesktop from '../../assets/tdx banner/BAAI-tdx-banner-desktop.webp'
import tdxMob from '../../assets/tdx banner/BAAI-TDX banner-mobile.webp'
import { CloseCircleFilled } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import { setUserData } from '../../Components/Redux/actions'
import '../../Components/DashboardComponents/dashboard.scss'
import './dashboard.scss'
import { Line } from 'react-chartjs-2'
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from 'chart.js'
import { getLastSevenDays } from '../../Components/functions'
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler)

const ROOT = `dashboard_product`

const EarningsGraph = props => {
  const { cardBackgroundColor } = props
  const graphEarning = [0, 15, 6, 10, 9, 13, 0]

  const xLabel = getLastSevenDays()

  const options = {
    responsive: true,
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
      },
    },
  }

  const data = {
    labels: xLabel,
    datasets: [
      {
        label: '',
        data: graphEarning,
        borderColor: '#1982CE', // Set the line color to blue
        pointBackgroundColor: 'white', // Set the fill color with opacity (adjust the color and opacity as needed)
        backgroundColor: 'rgba(25, 130, 206, 0.3)', // Set the fill color with opacity (adjust the color and opacity as needed)
        tension: 0.1,
        pointRadius: 8,
        borderWidth: 1,
        fill: true,
      },
    ],
  }
  return (
    <Card
      className={`dashboard_module__graph_ui`}
      style={{ backgroundColor: `${cardBackgroundColor}` }}
      title="Earnings"
      extra={
        // <Select
        //   defaultValue="Referrals"
        //   style={{
        //     width: 120,

        //   }}
        //   onChange={handleChange}
        //   options={[
        //     {
        //       value: "Daily",
        //       label: "Daily",
        //     },
        //     {
        //       value: "Weekly",
        //       label: "Weekly",
        //     },
        //     {
        //       value: "Monthly",
        //       label: "Monthly",
        //     },
        //   ]}
        // />
        <select
          className="select_filter"
          // onChange={e => console.log(e.target.value)}
        >
          <option value="referrals">Referrals</option>
          <option
            disabled
            value="engagements"
          >
            Engagement
          </option>
        </select>
      }
    >
      <div style={{ width: '100%' }}>
        <Line
          options={options}
          data={data}
          style={{ width: '100%', height: '200px' }}
        />
      </div>
    </Card>
  )
}

const DashboardBlur = () => {

  const location = useLocation();
  let url = location.search.substring(location.search.indexOf('?')+1);
  const yturl = url.startsWith("https://www.youtube.com");
  const {
    token: { colorBgContainer },
  } = theme.useToken()
  const userSignup = JSON.parse(localStorage.getItem('user-signup'))
  const cardBackgroundColor = '#F3F3F5'
  const [loginForm, setLoginForm] = useState(false)
  const navigate = useNavigate()
  const [handleSubmitBtn, setHandleSubmitBtn] = useState(false)
  // const [handleResetPasswordBtn, setHandleResetPasswordBtn] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    // Scroll to the top of the page on route change
    window.scrollTo(0, 0)
  }, [])

  const login = async values => {
    let formData = values
    formData.email = userSignup?.email
    // console.log(formData)
    if (formData.email && formData.password) {
      try {
        setHandleSubmitBtn(true)
        const response = await userService.loginUser(formData)
        // console.log('verify', verifyUser)
        if (response.error) {
          message.destroy()
          message.error(response?.error?.message || 'Something went worng in logging in')
          navigate('/login')
        } else {
          message.destroy()
          message.success(response?.message || 'Logged in successfully')
          let user = JSON.stringify(response?.data)
          dispatch(setUserData(user))
          localStorage.removeItem('user-signup')
          navigate('/dashboard?newuser=true')
          window.location.reload();
          if(yturl) window.open(url,"_newYT")
        }
      } catch (error) {
        // message.destroy()
        // message.error('Link Invalid or Expired')
        navigate('/login')
      }
      setHandleSubmitBtn(false)
    }
  }

  // const resendPassword = async () => {
  //   let formData = {}
  //   formData.email = userSignup?.email
  //   // console.log(formData)
  //   if (formData.email) {
  //     try {
  //       setHandleResetPasswordBtn(true)
  //       const response = await userService.resendEmail(formData)
  //       // console.log('verify', verifyUser)
  //       if (response.error) {
  //         message.destroy()
  //         message.error(response?.error?.message || 'Something went worng in resending email')
  //         navigate('/')
  //       } else {
  //         message.destroy()
  //         message.success(response?.message || 'Email sent successfully')
  //       }
  //     } catch (error) {
  //       // message.destroy()
  //       // message.error('Link Invalid or Expired')
  //       navigate('/')
  //     }
  //     setHandleResetPasswordBtn(false)
  //   }
  // }

  return (
    <Layout className={`${ROOT}__main_sider`}>
      <Modal
        open={showModal}
        // title="Set your password."
        onCancel={() => setShowModal(false)}
        closeIcon={<CloseCircleFilled style={{ fontSize: '20px' }} />}
        footer={null}
        centered
      >
        <div className="px-3 py-4 d-flex flex-column align-items-center text-center">
          <img
            alt="user"
            src={login_logo}
            width="40%"
            className="mb-3"
          />

          <p
            className="mt-3"
            style={{ fontFamily: '"Nunito", sans-serif', fontSize: '15px' }}
          >
            Our email services are currently down. <br></br>
            We apologise for the the inconvenience. <br></br>
            <br></br>
            Try again after some time.
          </p>
        </div>
      </Modal>
      <Sider
        theme="light"
        className={`side_module__sidebar`}
        breakpoint="lg"
        collapsedWidth="0"

        // onBreakpoint={broken => {
        //   console.log(broken)
        // }}
        // onCollapse={(collapsed, type) => {
        //   console.log(collapsed, type)
        // }}
      >
        <div className="demo-logo-vertical">
          <img
            alt="user"
            src={login_logo}
          />
        </div>
        <div className="profile">
          <div>
            <img
              alt="user"
              src={profile}
              height={42}
              width={42}
            />
          </div>
          <h5>{userSignup?.email}</h5>
        </div>

        <Menu
          className="mt-4"
          theme="light"
          defaultSelectedKeys={['1']}
          items={[
            {
              key: '1',
              icon: (
                <img
                  alt="user"
                  src={dash}
                  width="25"
                />
              ),
              label: 'My Dashboard',
            },
          ]}
        />
      </Sider>
      <Layout>
        <Affix offsetTop={0}>
          <Header
            style={{ padding: 0, background: colorBgContainer }}
            className={`${ROOT}__main_dash_header`}
          >
            <Row align="middle">
              <Col
                lg={24}
                xs={24}
                className="py-3 px-4"
              >
                {' '}
                <h3 className="header_title text-truncate mx-5">My Dashboard</h3>
              </Col>
              {/* <Col lg={12} xs={10} align="end">
              <Button type="light">
              <img
                src={wallet}
                alt="wallet"
              />{' '}
              Connect Wallet
            </Button>
              </Col> */}
            </Row>
          </Header>
        </Affix>
        <Content
          style={{
            // margin: '24px 16px',

            minHeight: 280,
            paddingTop: 0,

            background: colorBgContainer,
          }}
          className={`${ROOT}__content_body_main`}
        >
          <Row
            gutter={[0, 20]}
            style={{ background: colorBgContainer }}
            className="banner_ui"
          >
            <Col
              lg={24}
              xs={24}
              sm={24}
            >
              <ReferralBanner />
            </Col>
          </Row>
          <div style={{ position: 'relative', maxHeight: '35vh' }}>
            <Row className={`${ROOT}__card_ui mb-3`}>
              <Col lg={12}>
                <Card
                  style={{ backgroundColor: `${cardBackgroundColor}`, height: '100%' }}
                  className={`dashboard_module__card_ui`}
                >
                  <Row
                    gutter={[15, 0]}
                    className="token"
                  >
                    <Col>
                      <div>
                        <img
                          src={token}
                          alt="baai token"
                        />
                      </div>
                    </Col>
                    <Col>
                      <p>Total Balance</p>
                      <h4>
                        459.46 <span>BAAI</span>
                      </h4>
                    </Col>
                  </Row>
                  <Row
                    gutter={[40, 0]}
                    className="rewards mt-4"
                  >
                    <Col lg={8}>
                      <p>Total Rewards Earned</p>
                      <h4>
                        459.46 <span>BAAI</span>
                      </h4>
                    </Col>
                    <Col
                      lg={8}
                      className="br-r-l"
                    >
                      <p>Total Withdrawals</p>
                      <h4>
                        3459.46 <span>BAAI</span>
                      </h4>
                    </Col>
                    <Col lg={8}>
                      <p>Total Deposits</p>
                      <h4>
                        4659.46 <span>BAAI</span>
                      </h4>
                    </Col>
                  </Row>

                  <Row
                    gutter={[20, 0]}
                    className="rewards mt-4"
                  >
                    <Col lg={12}>
                      <Button
                        size="large"
                        disabled
                        block
                        icon={<DownloadOutlined />}
                      >
                        Deposit
                      </Button>
                    </Col>
                    <Col lg={12}>
                      <Button
                        size="large"
                        block
                        icon={<UploadOutlined />}
                      >
                        Withdraw
                      </Button>
                    </Col>
                  </Row>
                  <Row
                    align="middle"
                    className="mt-2 info"
                  >
                    <Col
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: '5px',
                      }}
                    >
                      <InfoCircleOutlined />
                    </Col>
                    <Col>
                      <p> Tokens will be available for trading in Q4 of 2024</p>
                    </Col>
                  </Row>

                  {/* {page} */}
                </Card>
              </Col>
              <Col lg={12}>
                <EarningsGraph
                  cardBackgroundColor={cardBackgroundColor}
                  page="my dashboard"
                />
              </Col>
            </Row>
            <div className={`${ROOT}__blur_card`}>
              <Row>
                <Col
                  lg={8}
                  className="m-auto pt-4 text-center"
                >
                  {/* {
                  !loginForm ? (
                    <div className="mb-4">
                      <h1>Login Required</h1>
                      <h6>to access your dashboard </h6>
                      <p>Use the password copied from the Register screen</p>
                      <Button
                        type="primary"
                        size="large"
                        block
                        onClick={() => {
                          setLoginForm(true)
                        }}
                      >
                        Login
                      </Button>
                      {/* <p className="mt-2">
                        Having difficulty finding the email?{' '}
                        <Link
                          // to="/"
                          onClick={() => resendPassword()}
                          disabled={handleResetPasswordBtn}
                        >
                          Resend it
                        </Link>
                      </p>
                      </div>
                  ) : ( */}
                    <div className="px-4 mb-4">
                      <h1>Login </h1>
                      <h6 className="mb-4">Enter your password to login and access your Dashboard</h6>
                      <Form
                        preserve={false}
                        name="forgot-password"
                        layout="vertical"
                        className="login-form"
                        initialValues={{
                          password: '',
                        }}
                        onFinish={login}
                        // onFinishFailed={onFinishFailed}
                      >
                        <Form.Item
                          className="mb-4"
                          name="password"
                          label="Enter Password"
                          rules={[
                            {
                              required: true,
                              message: 'Please input your password!',
                            },
                          ]}
                        >
                          <Input.Password
                            placeholder="Enter Password"
                            size="large"
                          />
                        </Form.Item>
                        <Form.Item className="mb-0">
                          <Button
                            block
                            size="large"
                            type="primary"
                            htmlType="submit"
                            className="login-form-button"
                            disabled={handleSubmitBtn}
                          >
                            Log in
                          </Button>
                        </Form.Item>
                      </Form>
                      {/* <Button
                      type="primary"
                      size="large"
                      block
                    >
                      Login
                    </Button> */}
                      {/* <p className="mt-2">
                        Having difficulty finding the email?{' '}
                        <Link
                          // to="/"
                          onClick={() => resendPassword()}
                          disabled={handleResetPasswordBtn}
                        >
                          Resend it
                        </Link>
                      </p> */}
                    </div>
                  {/* )
                  } */}
                </Col>
              </Row>
            </div>
          </div>
        </Content>
        <Row
          gutter={[0, 0]}
          style={{ background: colorBgContainer, marginTop: '100px' }}
          className="banner_ui px-0"
        >
          <Col
            xl={24}
            lg={24}
            md={24}
            sm={0}
            xs={0}
          >
            <div className="py-3">
              <Link
                to="https://tdx.biz/baai_giveaway/"
                target="_blank"
              >
                <img
                  width="100%"
                  src={tdxDesktop}
                  alt=""
                />
              </Link>
            </div>
          </Col>

          <Col
            xl={0}
            lg={0}
            md={0}
            sm={24}
            xs={24}
          >
            <div className="py-3">
              <Link
                to="https://tdx.biz/baai_giveaway/"
                target="_blank"
              >
                <img
                  width="100%"
                  src={tdxMob}
                  alt=""
                />
              </Link>
            </div>
          </Col>
        </Row>
      </Layout>
    </Layout>
  )
}

export default DashboardBlur
